import React from 'react';
import { Container, Wrapper } from './styles';
import { FilterPlans } from './partials/Filters';
import { ArrayPlans } from './partials/ArrayPlans';
import { useMediaQuery, query } from '@/hooks/useMediaQuery';
import { FloatingFilterButton } from '@/components/global/FloatingButton';

export const Plans: React.FC = () => {
  const { isMobile } = useMediaQuery(query);

  return (
    <Container>
      {!isMobile && ( <FloatingFilterButton /> )}
      <Wrapper>
        <FilterPlans />
        <ArrayPlans />
      </Wrapper>
    </Container>
  );
};
